import { render, staticRenderFns } from "./Edit_texure.vue?vue&type=template&id=09ed440e&"
import script from "./Edit_texure.vue?vue&type=script&lang=js&"
export * from "./Edit_texure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports